<sgt-grupo-classificacao-classificavel-form
    #form
    [entities]="entities">
</sgt-grupo-classificacao-classificavel-form>